import { render, staticRenderFns } from "./AnxCard.vue?vue&type=template&id=58212e84&"
import script from "./AnxCard.vue?vue&type=script&lang=ts&"
export * from "./AnxCard.vue?vue&type=script&lang=ts&"
import style0 from "./AnxCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports